/**
 * Phone Input Component with intl-tel-input
 * Initialise tous les inputs téléphone avec le plugin intl-tel-input
 */

import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';

export function initPhoneInputs() {
  const phoneInputs = document.querySelectorAll('[data-phone-input]');
  const instances = [];

  phoneInputs.forEach(input => {
    const iti = intlTelInput(input, {
      loadUtils: () => import("intl-tel-input/utils"),

      // Configuration avec détection auto par IP
      initialCountry: "auto",
      geoIpLookup: (callback) => {
        fetch("https://ipapi.co/json")
          .then(res => res.json())
          .then(data => callback(data.country_code))
          .catch(() => callback("cm")); // Fallback sur Cameroun si erreur
      },
      preferredCountries: [
        "cm", // Cameroun
        "fr", // France
        // Pays BEAC (Banque des États de l'Afrique Centrale)
        "cf", // République Centrafricaine
        "cg", // Congo
        "ga", // Gabon
        "gq", // Guinée Équatoriale
        "td", // Tchad
        // Pays BCEAO (Banque Centrale des États de l'Afrique de l'Ouest)
        "bj", // Bénin
        "bf", // Burkina Faso
        "ci", // Côte d'Ivoire
        "gw", // Guinée-Bissau
        "ml", // Mali
        "ne", // Niger
        "sn", // Sénégal
        "tg"  // Togo
      ],
      separateDialCode: true,
      autoPlaceholder: "aggressive",
      formatOnDisplay: true,
      nationalMode: false,

      // Personnalisation pour Tailwind
      customContainer: "w-full",

      // Options de validation
      strictMode: false,
      validationNumberType: "MOBILE"
    });

    instances.push({ input, iti });

    // Validation en temps réel
    input.addEventListener('blur', function () {
      if (input.value.trim()) {
        const isValid = iti.isValidNumber();
        const container = input.closest('.space-y-2');

        if (isValid) {
          // Retirer les erreurs
          input.classList.remove('border-red-300', 'focus:border-red-500', 'focus:ring-red-200');
          input.classList.add('border-gray-200', 'focus:border-secondary-500', 'focus:ring-secondary-200');

          // Retirer le message d'erreur s'il existe
          const existingError = container?.querySelector('.text-red-600');
          if (existingError) existingError.remove();
        } else {
          // Afficher l'erreur
          input.classList.remove('border-gray-200', 'focus:border-secondary-500', 'focus:ring-secondary-200');
          input.classList.add('border-red-300', 'focus:border-red-500', 'focus:ring-red-200');

          // Ajouter message d'erreur
          if (container && !container.querySelector('.text-red-600')) {
            const errorMsg = document.createElement('p');
            errorMsg.className = 'text-sm text-red-600 flex items-center gap-1';
            errorMsg.innerHTML = `
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
              </svg>
              Numéro de téléphone invalide
            `;
            container.appendChild(errorMsg);
          }
        }
      }
    });

    // Soumettre le formulaire avec le numéro complet en format international
    const form = input.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (input.value.trim()) {
          // Mettre à jour la valeur avec le numéro complet en format international
          const fullNumber = iti.getNumber();
          input.value = fullNumber;
        }
      });
    }
  });

  return instances;
}

// Fonction utilitaire pour obtenir une instance par input
export function getPhoneInputInstance(input) {
  return window.intlTelInputGlobals.getInstance(input);
}
